const UTM_SESSION_KEY = "ac_utm";

export interface UtmParams {
  channel?: string;
  medium?: string;
  source?: string;
}

export const saveUtmParams = (params: UtmParams): void => {
  try {
    sessionStorage.setItem(UTM_SESSION_KEY, JSON.stringify(params));
  } catch {
    // sessionStorage unavailable
  }
};

export const loadUtmParams = (): UtmParams | undefined => {
  try {
    const value = sessionStorage.getItem(UTM_SESSION_KEY);

    return value ? (JSON.parse(value) as UtmParams) : undefined;
  } catch {
    return undefined;
  }
};

// Helper function to get meta element content
export const getMetaContent = (name: string): string | undefined => {
  const meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);

  return meta?.content || undefined;
};

// Helper function to determine if an element is a booking button link
export const isBookingButton = (element: HTMLElement): boolean => {
  const href = element.getAttribute("href");

  if (
    element.dataset.bookingButton !== undefined ||
    element.dataset.vetstoriaBookingButton !== undefined ||
    href?.includes("//anicura.provetcloud.com") === true ||
    href?.includes("petleo.app") === true ||
    href?.includes("abupet.com") === true ||
    href?.includes("app.petsxl") === true ||
    href?.includes("appointment-registration") === true ||
    href?.includes("booking.vetstoria.com") === true
  ) {
    return true;
  }

  const bookingUrl = getMetaContent("booking-url");

  if (bookingUrl && href) {
    try {
      const bookingUri = new URL(bookingUrl, window.location.href);
      const hrefUri = new URL(href, window.location.href);
      const bookingPath = bookingUri.pathname.replace(/\/+$/, "");
      const hrefPath = hrefUri.pathname.replace(/\/+$/, "");

      return bookingUri.hostname === hrefUri.hostname && bookingPath === hrefPath;
    } catch {
      // invalid URL
    }
  }

  return false;
};
